export const GET_ALL_CREDENTIAL_SUCCESS = "GET_ALL_CREDENTIAL_SUCCESS"
export const GET_ALL_CREDENTIAL_LOADING = "GET_ALL_CREDENTIAL_LOADING"
export const ADD_NEW_CREDENTIAL= "ADD_NEW_CREDENTIAL"
export const  DELETE_CREDENTIAL = "DELETE_CREDENTIAL"
export const UPDATE_CREDENTIAL = "UPDATE_CREDENTIAL"